(function () {
    "use strict";
    var card = document.querySelector("[data-major-alert]");
    if (!card) return;
    var proxy;
    try {
        proxy = new URL(card.dataset.proxyUrl, window.location.href);
        if (proxy.protocol !== "https:" && proxy.origin !== window.location.origin) return;
    } catch (error) { return; }
    var endpoint = proxy.href.replace(/\/$/, "") + "/major-alerts";
    var storageKey = "bahnnews-major-alerts-v1";
    var maxAge = 20 * 60 * 1000;
    var dismissAge = 12 * 60 * 60 * 1000;
    var current = null;
    var timer;
    var loading = false;
    var staleTimer;
    var records = {};
    try { records = JSON.parse(localStorage.getItem(storageKey) || "{}") || {}; } catch (error) { records = {}; }
    var cookie = document.querySelector("[data-cookie-banner]");
    var cookieModal = document.querySelector("[data-cookie-modal]");
    var de = document.documentElement.lang.toLowerCase().indexOf("de") === 0;

    function save() {
        Object.keys(records).forEach(function (key) {
            if (!records[key] || Date.now() - records[key].seenAt > dismissAge) delete records[key];
        });
        try { localStorage.setItem(storageKey, JSON.stringify(records)); } catch (error) { /* In-memory dismissal still works. */ }
    }

    // A deliberate reload shows current alerts again; ordinary navigation keeps dismissals.
    var navigation = window.performance && typeof window.performance.getEntriesByType === "function" &&
        window.performance.getEntriesByType("navigation")[0];
    if (navigation && navigation.type === "reload") {
        Object.keys(records).forEach(function (key) {
            if (records[key]) records[key].dismissedAt = null;
        });
        save();
    }

    function related(alert) {
        return records[alert.id] || Object.keys(records).map(function (key) { return records[key]; }).find(function (record) {
            return record && record.alert && record.alert.noticeIds.some(function (id) { return alert.noticeIds.includes(id); });
        });
    }

    function significant(before, after) {
        return before.severity !== after.severity ||
            after.lines.some(function (line) { return !before.lines.includes(line); }) ||
            after.sections.some(function (section) { return !before.sections.includes(section); }) ||
            after.durationMinutes !== null && before.durationMinutes !== null && after.durationMinutes - before.durationMinutes >= 60 ||
            before.expectedUntil && after.expectedUntil && Date.parse(after.expectedUntil) - Date.parse(before.expectedUntil) >= 60 * 60 * 1000;
    }

    function position() {
        if (card.hidden) return;
        var rect = cookie && !cookie.hidden ? cookie.getBoundingClientRect() : null;
        var bottom = rect ? Math.max(0, window.innerHeight - rect.top) + 12 : 16;
        card.style.setProperty("--major-alert-bottom", bottom + "px");
        card.classList.toggle("has-cookie-banner", Boolean(rect));
        // A deliberately opened settings dialog retains keyboard focus and precedence.
        card.inert = Boolean(cookieModal && !cookieModal.hidden);
    }

    function hide() {
        card.hidden = true;
        current = null;
        document.body.classList.remove("has-major-alert");
        window.clearTimeout(staleTimer);
    }

    function dismiss() {
        if (!current) return;
        records[current.id] = {alert: current, dismissedAt: Date.now(), seenAt: Date.now()};
        save();
        var focused = card.contains(document.activeElement);
        hide();
        if (focused) {
            var main = document.getElementById("main-content");
            if (main) {
                var original = main.getAttribute("tabindex");
                main.setAttribute("tabindex", "-1");
                main.focus({preventScroll: true});
                if (original === null) main.removeAttribute("tabindex");
                else main.setAttribute("tabindex", original);
            }
        }
    }

    function valid(alert) {
        return alert && typeof alert.id === "string" && typeof alert.title === "string" &&
            (alert.severity === "interruption" || alert.severity === "restriction") &&
            [alert.lines, alert.sections, alert.noticeIds].every(Array.isArray) &&
            (!alert.expectedUntil || Date.parse(alert.expectedUntil) > Date.now()) &&
            (!alert.validUntil || Date.parse(alert.validUntil) > Date.now());
    }

    function render(payload) {
        var fetched = Date.parse(payload.fetchedAt);
        var age = Date.now() - fetched;
        if (payload.source !== "oebb-hafas" || !Number.isFinite(age) || age < -60000 || age >= maxAge || !Array.isArray(payload.alerts)) {
            hide();
            return;
        }
        var alerts = payload.alerts.filter(valid);
        var alert = alerts.find(function (item) {
            var record = related(item);
            return !record || !record.dismissedAt || Date.now() - record.dismissedAt >= dismissAge || significant(record.alert, item);
        });
        if (!alert) { hide(); return; }
        var record = related(alert);
        var previous = current && current.id === alert.id ? current : record && record.alert;
        var updated = Boolean(previous && (previous.title !== alert.title || previous.text !== alert.text || significant(previous, alert)));
        var unchanged = current && JSON.stringify(current) === JSON.stringify(alert) && !card.hidden;
        if (unchanged) {
            window.clearTimeout(staleTimer);
            var deadline = Math.min(fetched + maxAge, alert.validUntil ? Date.parse(alert.validUntil) : Infinity,
                alert.expectedUntil ? Date.parse(alert.expectedUntil) : Infinity);
            staleTimer = window.setTimeout(hide, Math.max(0, deadline - Date.now()));
            return;
        }
        if (!current || current.id !== alert.id) card.querySelector(".major-alert-copy").scrollTop = 0;
        current = alert;
        card.dataset.severity = alert.severity;
        card.querySelector("[data-major-alert-status]").textContent = alert.severity === "interruption" ?
            (de ? "Unterbrechung" : "Interruption") : (de ? "Einschränkung" : "Restriction");
        card.querySelector("[data-major-alert-title]").textContent = alert.title;
        card.querySelector("[data-major-alert-text]").textContent = alert.text || "";
        var badge = card.querySelector("[data-major-alert-update]");
        if (updated || alert.sourceUpdate) badge.hidden = false;
        else if (!previous || previous.id !== alert.id) badge.hidden = true;
        var modified = Date.parse(alert.modified);
        card.querySelector("[data-major-alert-time]").textContent = Number.isFinite(modified) ?
            (de ? "Meldungsstand: " : "Notice updated: ") + new Intl.DateTimeFormat(de ? "de-AT" : "en-GB", {
                timeZone: "Europe/Vienna", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit"
            }).format(new Date(modified)) + (de ? " · Quelle: ÖBB" : " · Source: ÖBB") :
            (de ? "Meldungszeit nicht angegeben · Quelle: ÖBB" : "Notice time not provided · Source: ÖBB");
        records[alert.id] = {alert: alert, dismissedAt: null, seenAt: Date.now()};
        save();
        card.hidden = false;
        document.body.classList.add("has-major-alert");
        position();
        window.clearTimeout(staleTimer);
        var expires = Math.min(fetched + maxAge, alert.validUntil ? Date.parse(alert.validUntil) : Infinity,
            alert.expectedUntil ? Date.parse(alert.expectedUntil) : Infinity);
        staleTimer = window.setTimeout(hide, Math.max(0, expires - Date.now()));
    }

    function poll() {
        window.clearTimeout(timer);
        if (document.hidden || loading) return;
        loading = true;
        var controller = new AbortController();
        var timeout = window.setTimeout(function () { controller.abort(); }, 8000);
        fetch(endpoint, {credentials: "omit", signal: controller.signal})
            .then(function (response) { if (!response.ok) throw new Error("Alert unavailable"); return response.json(); })
            .then(render)
            .catch(function () { /* Keep a previously verified card only until its freshness deadline. */ })
            .finally(function () {
                window.clearTimeout(timeout);
                loading = false;
                if (!document.hidden) timer = window.setTimeout(poll, 2 * 60 * 1000);
            });
    }
    card.querySelectorAll("[data-major-alert-close]").forEach(function (button) { button.addEventListener("click", dismiss); });
    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !card.hidden && !card.inert && !document.body.classList.contains("menu-open")) dismiss();
    });
    window.addEventListener("resize", position, {passive: true});
    if (cookie) {
        new MutationObserver(position).observe(cookie, {attributes: true, attributeFilter: ["hidden"]});
        if ("ResizeObserver" in window) new ResizeObserver(position).observe(cookie);
    }
    if (cookieModal) new MutationObserver(position).observe(cookieModal, {attributes: true, attributeFilter: ["hidden"]});
    document.addEventListener("visibilitychange", function () {
        window.clearTimeout(timer);
        if (!document.hidden) poll();
    });
    window.addEventListener("pageshow", function (event) { if (event.persisted) poll(); });
    poll();
}());
